export const getHomePageTourSteps = t => [
  {
    target: '[data-tour="navCertification"]',
    message: t('demoTour.navCertificationMessage'),
  },
  {
    target: '[data-tour="navGuide"]',
    message: t('demoTour.navGuideMessage'),
  },
  {
    target: '[data-tour="certified-until"]',
    message: t('demoTour.certifiedMessage'),
  },
  {
    target: '[data-tour="create-submission"]',
    message: t('demoTour.createMessage'),
  },
  {
    target: '[data-tour="active-certifications"]',
    message: t('demoTour.activeMessage'),
  },
  {
    target: '[data-tour="completed-certifications"]',
    message: t('demoTour.completedMessage'),
  },
];
